import { useEffect } from 'react';
import { useToast } from '../components/ui/toast-context';
import { useT } from '../lib/i18n';
import { commonMessages } from '../lib/i18n/messages/common';

/** Registers the service worker and offers a reload when a new version is waiting. */
export function PwaUpdater() {
  const toast = useToast();
  const t = useT(commonMessages);
  useEffect(() => {
    if (import.meta.env.MODE === 'mock' || import.meta.env.MODE === 'test') return;
    let cancelled = false;
    void import('virtual:pwa-register').then(({ registerSW }) => {
      if (cancelled) return;
      const update = registerSW({
        immediate: true,
        onNeedRefresh() {
          toast({
            message: t('updateAvailable'),
            duration: Infinity,
            action: { label: t('reload'), onClick: () => void update(true) },
          });
        },
      });
    });
    return () => {
      cancelled = true;
    };
  }, [toast, t]);
  return null;
}
